import PropTypes from 'prop-types'
import { Controller, useFormContext } from 'react-hook-form'
import { Typography, FormLabelStyled, FormTextStyled } from '../styled'
import { PillRow, Pill } from './fieldStyled'

export default function InlineMultiSelectInput({
  name,
  label,
  required,
  options = [],
  maxLimit,
}) {
  const { control } = useFormContext()

  const toggle = (current, value) => {
    const list = Array.isArray(current) ? current : []
    if (list.includes(value)) return list.filter((v) => v !== value)
    if (maxLimit && list.length >= maxLimit) return list
    return [...list, value]
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const selected = Array.isArray(field.value) ? field.value : []
        return (
          <div className="mb-3">
            <FormLabelStyled>
              <Typography size="12px">
                {label}
                {required && <span className="text-danger">*</span>}
              </Typography>
            </FormLabelStyled>
            <PillRow>
              {options.map((option) => (
                <Pill
                  key={option.value}
                  type="button"
                  active={selected.includes(option.value)}
                  onClick={() => field.onChange(toggle(selected, option.value))}
                >
                  {option.label}
                </Pill>
              ))}
            </PillRow>
            {fieldState.error && (
              <FormTextStyled isError>
                {fieldState.error.message}
              </FormTextStyled>
            )}
          </div>
        )
      }}
    />
  )
}

InlineMultiSelectInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  maxLimit: PropTypes.number,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.node,
    }),
  ),
}
